import { ButtonProps as MuiButtonProps } from '@material-ui/core';
import { forwardRef } from 'react';
import * as S from './styles';

export interface ButtonProps extends MuiButtonProps {
  testId?: string;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, testId = 'button', size = 'medium', ...props }, ref) => {
    return (
      <S.Button data-testid={testId} size={size} variant="contained" ref={ref} {...props}>
        {children}
      </S.Button>
    );
  },
);
